import {
    StyleSheet
} from "react-native";
import type {
    PaginationContentDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1
    },
    item: {
        flexDirection: "row"
    }
});

export const useStyles = ({
    spaces
}: PaginationContentDynamicStyleType) => {
    return {
        container: {
            gap: spaces.spacingXxs
        }
    };
};
export default stylesheet;
